import { dashboard } from 'js/src/data/dashboard/dashboard-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/dashboard/dashboard-operations';
export * from 'js/src/data/dashboard/dashboard-selectors';
export * from 'js/src/data/dashboard/dashboard-types';
export * from 'js/src/data/dashboard/dashboard-actions';
export * from 'js/src/data/dashboard/dashboard-utils';
export { VIDEOS_ORM_PREFIX } from 'js/src/data/dashboard/dashboard-types';

export default dashboard;
